// Pure mappers: raw blustreamApi shapes -> the shapes deriveModel / segmentChips consume.
export function adaptTouchpoint(tp) {
  return {
    touchpoint_id: tp.touchpoint_id,
    journey_id: tp.journey_id,
    ordinal: tp.ordinal,
    name: tp.name,
    message: tp.message,
    wait_time: tp.wait_time,
    response_attribute_id: tp.response_attribute_id != null ? String(tp.response_attribute_id) : null,
    link: tp.link || null,
    labels: tp.labels || [],
  };
}

export function adaptJourney(j, touchpoints = []) {
  return {
    journey_id: j.journey_id,
    name: j.name,
    state_enum: j.state_enum,
    is_active: j.is_active,
    segment_id: j.segment_id,
    channels: j.channels || [], // real API has no channels; keep [] so meta/joins are safe
    labels: j.labels || [],
    touchpoints: touchpoints.map(adaptTouchpoint),
  };
}

export const adaptSegment = (s) => s; // condition shape already matches the model

export function buildAttributeIndex(attrs = []) {
  const byId = new Map(attrs.map((a) => [String(a.attribute_id), { attribute_id: a.attribute_id, name: a.name }]));
  return (id) => byId.get(String(id)) || null;
}
